// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ - REUTILIZANDO IMPORTS EXACTOS DEL ARCHIVO ORIGINAL
// Este archivo mapea los elementos del menú actual a la nueva estructura agrupada

import React from 'react';

// ✅ IMPORTS EXACTOS DEL ARCHIVO ORIGINAL (MainListItems.js)
// eslint-disable-next-line no-unused-vars
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CardMembershipIcon from '@material-ui/icons/CardMembership';
// import RotateRight from "@material-ui/icons/RotateRight"; // ✅ No utilizado por ahora
import LoyaltyRoundedIcon from '@material-ui/icons/LoyaltyRounded';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { AllInclusive, AttachFile, DeviceHubOutlined, Schedule, Speed as SpeedIcon, Assessment as AssessmentIcon, AccountTree, Tune } from '@material-ui/icons';
// eslint-disable-next-line no-unused-vars
import { FaBell } from 'react-icons/fa';

// ✅ FUNCIÓN UNIFICADA PARA RENDERIZAR ICONOS CON ESTILO CONSISTENTE
const renderIconUnified = (IconComponent) => {
  return (
    <IconComponent 
      style={{ 
        fontSize: '20px',
        color: 'inherit',
        transition: 'all 0.2s ease-in-out',
      }}
    />
  );
};

// ✅ FUNCIONES DE ICONOS (MANTENIDAS PARA COMPATIBILIDAD, PERO USAN ESTILO UNIFICADO)
const renderIconWhatsApp = renderIconUnified;
const renderIconDashboard = renderIconUnified;
const renderIconMensajes = renderIconUnified;
const renderIconConfiguracion = renderIconUnified;
const renderIconUtilidades = renderIconUnified;
const renderIconGruposWA = renderIconUnified;

// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ
export const menuGroupsConfig = {
  whatsapp: {
    id: 'whatsapp',
    title: 'Chats',
    icon: '💬',
    color: '#3B82F6',
    renderIcon: renderIconWhatsApp,
    expanded: true, // ✅ Expandido por defecto
    items: [
      {
        name: 'Tickets',
        route: '/tickets',
        icon: WhatsAppIcon,
        translationKey: 'mainDrawer.listItems.tickets',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Respuestas rápida',
        route: '/quick-messages',
        icon: FlashOnIcon,
        translationKey: 'mainDrawer.listItems.quickMessages',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Kanban',
        route: '/kanban',
        icon: LoyaltyRoundedIcon,
        translationKey: 'Kanban',
        permission: 'drawer-service-items:view',
        conditional: 'showKanban'
      },
      {
        name: 'Apuntes',
        route: '/todolist',
        icon: BorderColorIcon,
        translationKey: 'hardcodedElements.tarefas',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Contactos',
        route: '/contacts',
        icon: ContactPhoneOutlinedIcon,
        translationKey: 'mainDrawer.listItems.contacts',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Agenda',
        route: '/schedules',
        icon: Schedule,
        translationKey: 'mainDrawer.listItems.schedules',
        permission: 'drawer-service-items:view',
        conditional: 'showSchedules'
      },
      {
        name: 'Etiquetas',
        route: '/tags',
        icon: LocalOfferIcon,
        translationKey: 'mainDrawer.listItems.tags',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Lista de archivos',
        route: '/files',
        icon: AttachFile,
        translationKey: 'mainDrawer.listItems.files',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'Ayuda',
        route: '/helps',
        icon: HelpOutlineIcon,
        translationKey: 'mainDrawer.listItems.helps',
        permission: 'drawer-service-items:view'
      },
      {
        name: 'API',
        route: '/messages-api',
        icon: CodeRoundedIcon,
        translationKey: 'mainDrawer.listItems.messagesAPI',
        permission: 'drawer-admin-items:view', // ✅ MANTENER: Solo admins pueden usar API
        conditional: 'showExternalApi'
      }
    ]
  },
  
  dashboard: {
    id: 'dashboard',
    title: 'Dashboard',
    icon: '📊',
    color: '#10B981',
    renderIcon: renderIconDashboard,
    expanded: false,
    route: null, // ✅ Sin ruta directa - solo submenús
    items: [
      {
        name: 'Métricas',
        route: '/',
        icon: DashboardOutlinedIcon,
        translationKey: 'mainDrawer.listItems.dashboard',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Conexiones',
        route: '/dashboard/connections',
        icon: SyncAltIcon,
        translationKey: 'Conexiones',
        permission: 'drawer-admin-items:view'
      },
      // ✅ ELIMINADO: "Rendimiento CPU" - Ya no se necesita, reemplazado por "Rendimiento VPS"
      {
        name: 'WhatsApp',
        route: '/dashboard/whatsapp',
        icon: WhatsAppIcon,
        translationKey: 'WhatsApp',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super' // Solo super admin
      },
      {
        name: 'Rendimiento VPS',
        route: '/dashboard/vps-performance',
        icon: SpeedIcon,
        translationKey: 'Rendimiento VPS',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super' // Solo super admin
      }
    ]
  },
  
  gruposWA: {
    id: 'gruposWA',
    title: 'Grupos de WA',
    icon: '👥',
    color: '#06B6D4',
    renderIcon: renderIconGruposWA,
    expanded: false,
    items: [
      {
        name: 'Lista de Grupos',
        route: '/groups-wa',
        icon: PeopleIcon,
        translationKey: 'mainDrawer.listItems.groupsWA',
        permission: 'drawer-admin-items:view' // ✅ Solo admins pueden acceder
      },
      {
        name: 'Campañas de Grupos',
        route: '/group-campaigns',
        icon: ListIcon,
        translationKey: 'Campañas de Grupos WA',
        permission: 'drawer-admin-items:view' // ✅ Solo admins pueden acceder
      }
    ]
  },
  
  mensajes: {
    id: 'mensajes',
    title: 'Mensajeria',
    icon: '📢',
    color: '#F59E0B',
    renderIcon: renderIconMensajes,
    expanded: false,
    items: [
      {
        name: 'Envío de mensajes',
        route: '/campaigns',
        icon: ListIcon,
        translationKey: 'hardcodedElements.listagem',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Lista de contactos',
        route: '/contact-lists',
        icon: PeopleIcon,
        translationKey: 'Listas de Contatos',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      {
        name: 'Informe de Envío',
        route: '/campaign-shipping-reports',
        icon: AssessmentIcon,
        translationKey: 'Informe de Envío',
        permission: 'drawer-admin-items:view',
        conditional: 'showCampaigns'
      },
      // ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas
      // {
      //   name: 'Tiempos de envío',
      //   route: '/campaigns-config',
      //   icon: ListIcon,
      //   translationKey: 'hardcodedElements.configuracoes',
      //   permission: 'drawer-admin-items:view',
      //   conditional: 'showCampaigns'
      // }
    ]
  },
  
  configuracion: {
    id: 'configuracion',
    title: 'Configuración',
    icon: '⚙️',
    color: '#EF4444',
    renderIcon: renderIconConfiguracion,
    expanded: false,
    items: [
      {
        name: 'Conexiones',
        route: '/connections',
        icon: SyncAltIcon,
        translationKey: 'mainDrawer.listItems.connections',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Departamentos',
        route: '/queues',
        icon: AccountTreeOutlinedIcon,
        translationKey: 'mainDrawer.listItems.queues',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Agentes IA',
        route: '/prompts',
        icon: AllInclusive,
        translationKey: 'mainDrawer.listItems.prompts',
        permission: 'drawer-admin-items:view',
        conditional: 'showOpenAi'
      },
      {
        name: 'Rol de usuario',
        route: '/users',
        icon: PeopleAltOutlinedIcon,
        translationKey: 'mainDrawer.listItems.users',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Subscripción',
        route: '/financeiro',
        icon: CardMembershipIcon,
        translationKey: 'mainDrawer.listItems.financeiro',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Configuraciones',
        route: '/settings',
        icon: SettingsOutlinedIcon,
        translationKey: 'mainDrawer.listItems.settings',
        permission: 'drawer-admin-items:view'
      }
    ]
  },
  
  flowbuilder: {
    id: 'flowbuilder',
    title: 'FlowBuilder',
    icon: '🔄',
    color: '#9C27B0',
    renderIcon: renderIconUtilidades,
    expanded: false,
    items: [
      {
        name: 'Lista de Flujos',
        route: '/flowbuilders',
        icon: AccountTree,
        translationKey: 'mainDrawer.listItems.flowbuilders',
        permission: 'drawer-admin-items:view'
      },
      {
        name: 'Campañas de Flujo',
        route: '/flowcampaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.flowcampaigns',
        permission: 'drawer-admin-items:view'
      }
    ]
  },
  
  utilidades: {
    id: 'utilidades',
    title: 'Utilitarios',
    icon: '🔧',
    color: '#8B5CF6',
    renderIcon: renderIconUtilidades,
    expanded: false,
    items: [
      {
        name: 'Integraciones',
        route: '/queue-integration',
        icon: DeviceHubOutlined,
        translationKey: 'mainDrawer.listItems.queueIntegration',
        permission: 'drawer-admin-items:view',
        conditional: 'showIntegrations'
      },
      {
        name: 'Chat local',
        route: '/chats',
        icon: ForumIcon,
        translationKey: 'mainDrawer.listItems.chats',
        permission: 'drawer-service-items:view',
        conditional: 'showInternalChat'
      },
      {
        name: 'Anuncios',
        route: '/announcements',
        icon: AnnouncementIcon,
        translationKey: 'mainDrawer.listItems.annoucements',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super'
      },
      {
        name: 'Meta',
        route: '/hub-notificame',
        icon: FaBell,
        translationKey: 'Meta',
        permission: 'drawer-admin-items:view',
        conditional: 'user.super'
      }
    ]
  }
};

// ✅ FUNCIONES HELPER
export const getMenuGroupConfig = (groupId) => {
  return menuGroupsConfig[groupId] || null;
};

export const getAllMenuGroups = () => {
  return Object.values(menuGroupsConfig);
};

export const getMenuGroupItems = (groupId) => {
  const group = getMenuGroupConfig(groupId);
  return group ? group.items : [];
};